import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { Router } from '@angular/router';
import { trigger } from 'devextreme/events';
import { ModalComponent, Workspace } from 'app/internal/shared';

@Component({
  selector: 'sp-admin-portfolio-list',
  templateUrl: './admin-portfolio-list.component.html',
  styleUrls: ['./admin-portfolio-list.component.scss'],
  standalone: false
})

export class AdminPortfolioListComponent implements OnChanges {

  @ViewChild('dxAdminPortfolioDataGrid', { static: false }) dxAdminPortfolioDataGrid: DxDataGridComponent;

  readonly allowedPageSizes = [10, 25, 50, 'all'];
  @Input() workspaces: Workspace[];
  @Input() portfolioFilterSettings: string;
  @Output() deactivate = new EventEmitter<string>();
  @Output() reactivate = new EventEmitter<string>();
  @Output() filterChanged: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('deactivatePortfolioModal', { static: true }) public deactivatePortfolioModal: ModalComponent;
  @ViewChild('reactivatePortfolioModal', { static: true }) public reactivatePortfolioModal: ModalComponent;
  toggleStatusWorkspaceId: string;
  dataGridSource: any;
  activeFilterItems = [
    { value:'active', text: 'Active' }, 
    { value: 'inactive', text: 'Inactive' }, 
    { value: 'all', text: 'All' }
  ];  
  selectedValue = 'active';

  constructor(private router: Router) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.workspaces && this.workspaces) {
      this.updateDataGridSource();
    }
  }
    
  activeDropdownChanged(e: any) {
    this.selectedValue = e.value;
    this.updateDataGridSource();
  }

  updateDataGridSource() {
    if (this.selectedValue === 'active') {
      this.dataGridSource = this.workspaces?.filter(x => x.isActive == true);
    } else if (this.selectedValue === 'inactive') {
      this.dataGridSource = this.workspaces?.filter(x => x.isActive == false);
    } else {
      this.dataGridSource = this.workspaces;
    }
  }

  dxGridRowPrepared(e) {
    // https://supportcenter.devexpress.com/ticket/details/t744353/datagrid-how-to-change-the-row-height
    if (e.rowType === 'data') {
      e.rowElement.style.height = '40px';
    }
  }

  showActionMenu(e) {
    // This allows us to either left or right click to show the menu.
    const newEvent = Object.assign({}, e.event, { type: 'dxcontextmenu' });
    e.event.stopPropagation();
    trigger(e.element, newEvent);
  }

  onSearchValueChanged(e) {  
    if (e.fullName == 'searchPanel.text' && this.portfolioFilterSettings !== e.value) {
      this.filterChanged.emit(e.value);
    }
  } 

  onContextMenuPreparing(e) {

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this;
    // Only show the Context Menu if the Menu Button is clicked!
    if (e.row.rowType === 'data' && e.column.cellTemplate === 'workspaceId') {

      const workspaceId = e.row.data.workspaceId;

      const toggleActiveStatusMenuItem = {
        text: e.row.data.isActive ? 'Deactivate' : 'Reactivate',
        onItemClick: function () {
          that.toggleStatusWorkspaceId = workspaceId;
          if (e.row.data.isActive) {
            that.deactivatePortfolioModal.show();
          } else {
            that.reactivatePortfolioModal.show();
          }
        }
      };

      e.items = [
        {
          text: 'Edit',
          onItemClick: function () {
            that.router.navigate(['/useraccount/admin/portfolios/' + workspaceId]);
          }
        },
        toggleActiveStatusMenuItem
      ];
    }
  }

  deactivatePortfolio() {
    this.deactivate.emit(this.toggleStatusWorkspaceId);
    this.toggleStatusWorkspaceId = null;
  }

  reactivatePortfolio() {
    this.reactivate.emit(this.toggleStatusWorkspaceId);
    this.toggleStatusWorkspaceId = null;
  }
}
